// store/modules/shopeeCategories.js

// Variável estática no escopo do módulo para controlar a Promise em andamento
let fetchCategoriesPromise = null;

export default {
    namespaced: true,

    state: {
        categories: null,
    },

    getters: {
        getCategories: state => state.categories,
    },

    mutations: {
        SET_CATEGORIES(state, categories) {
            state.categories = categories;
        },
    },

    actions: {
        async fetchCategories({ commit, state }) {
            // 1. Se já temos as categorias em cache, retornamos imediatamente
            if (state.categories) {
                return Promise.resolve(state.categories);
            }

            // 2. Se já existe uma Promise pendente, retornamos a mesma
            if (fetchCategoriesPromise) {
                return fetchCategoriesPromise;
            }

            // 3. Não há cache nem Promise pendente; vamos criar a Promise
            fetchCategoriesPromise = new Promise(async (resolve, reject) => {
                try {
                    // Chamando a facade do Axios pela window
                    const response = await window.http.get('/v2/marketplaces/shopee/categories');
                    const categoriesData = response.data;

                    commit('SET_CATEGORIES', categoriesData);

                    // Limpamos a variável estática após concluir a requisição
                    fetchCategoriesPromise = null;
                    resolve(categoriesData);

                } catch (error) {
                    // Em caso de erro, limpamos a Promise estática também
                    fetchCategoriesPromise = null;
                    reject(error);
                }
            });

            return fetchCategoriesPromise;
        },
    },
};
